import { img } from "./helpers";

export const hiddenSupTour = {
  id: "hiddenSup",
  slug: "hidden-sup",
  href: "/tours/hidden-sup",
  isComingSoon: true,
  categoryKey: "general",
  images: [
    img("v1785005393/DSC00191_small_lhfvnk.jpg"),
    img("v1785005393/DJI_20260722152001_0021_D_small_odgfk0.jpg"),
    img(
      "v1784950297/%E3%82%B9%E3%82%AF%E3%83%AA%E3%83%BC%E3%83%B3%E3%82%B7%E3%83%A7%E3%83%83%E3%83%88_2026-07-25_12.30.45_x4brgv.png",
    ),
  ],
  tags: ["drone", "camera", "sup", "private", "secret"],
  time: "2h",
  salePrice: {
    amount: 12000,
    unit: "person",
  },
  texts: {
    JP: {
      title: "【1組限定】秘境SUPツアー",
      startTimes: ["10:00"],
      people: "1-4名様",
      notes: "※おひとり様でご参加の場合は¥15,000になります。",
    },
    EN: {
      title: "Private Hidden SUP Tour",
      startTimes: ["10:00"],
      people: "1-4 guests",
      notes:
        "※Solo guest price is ¥15,000.",
    },
    中文: {
      title: "【仅限1组】私人秘境 SUP 行程",
      startTimes: ["10:00"],
      people: "1-4人",
      notes: "※1人参加时为¥15,000。",
    },
    한국어: {
      title: "【1팀 한정】프라이빗 히든 SUP 투어",
      startTimes: ["10:00"],
      people: "1-4명",
      notes:
        "※1인 참가 시 ¥15,000입니다.",
    },
  },
  detail: {
    heroImage: img("v1785005393/DJI_20260722152001_0021_D_small_odgfk0.jpg"),
    heroYoutubeUrl: "https://www.youtube.com/watch?v=Lrb9aTqIfsA",
    isVertical: false,
    showCustomize: false,
    youtubeUrl: "",
    videoGallery: [
      {
        src: "https://res.cloudinary.com/drxijtp8g/video/upload/v1785305717/Timeline_1_dltxzs.mp4",
        label: "涙が出るほど美しい海を独り占め",
      },
      {
        src: "https://res.cloudinary.com/drxijtp8g/video/upload/v1785309244/sup2_lgldqv.mp4",
        label: "圧倒的な映像クオリティを保証",
        orientation: "landscape",
      },
      {
        src: "https://res.cloudinary.com/drxijtp8g/video/upload/v1785170045/Timeline_1_otl8ph.mp4",
        label: "ここでしか味わえない究極の非日常体験",
        orientation: "landscape",
      },
      {
        src: "https://res.cloudinary.com/drxijtp8g/video/upload/v1785170133/Timeline_1_fq4wdw.mp4",
        label: "一生見返したくなる映像",
        orientation: "landscape",
      },
    ],
    images: [
      img("v1785311438/DSC00522_vyppts.webp"),
      img("v1785774919/DJI_20260802130948_0022_D_qgtfej.webp"),
      img("v1785311757/IMG_8564_jkfm7r.webp"),
      img("v1785776522/DSC00843_co2jqa.webp"),
      img("v1784767636/IMG_5428_oepvhn.jpg"),
      img("v1785774919/DJI_20260801191604_0048_D_t2h5kf.webp"),
      img("v1784767309/IMG_5481_ie849d.jpg"),
      img("v1784766585/DJI_20260722154007_0060_D_azbuxt.webp"),
      img("v1784766584/DJI_20260722151517_0012_D_mxjroa.webp"),
      img("v1785774919/DJI_20260802130435_0005_D_ttelkm.webp"),
      img("v1785005393/DJI_20260722152001_0021_D_small_odgfk0.jpg"),
      img("v1785776522/DJI_20260802131800_0033_D_drlb1i.webp"),
      img("v1785005395/DSC00157_small_rnomp6.jpg"),
      img("v1785774920/DJI_20260802130529_0008_D_lmtja6.webp"),
      img("v1785005394/DSC00161_small_f5qnkn.jpg"),
      img("v1785005393/DSC00178_small_hexny7.jpg"),
      img("v1785774919/DJI_20260802130401_0003_D_ngu1sv.webp"),
      img("v1784189987/image4_gbt8eh.webp"),
      img("v1785776523/DSC00815_yry3re.webp"),
      img("v1783930567/DSC00215_gpomzw.webp"),
      img("v1785774919/DJI_20260801191615_0050_D_rqjave.webp"),
      img("v1785005393/DSC00191_small_lhfvnk.jpg"),
      img("v1785776522/DSC00817_ag3z9t.webp"),
      img("v1784268598/DSC00189_pslhwt.webp"),
      img("v1785774919/DJI_20260802131128_0026_D_rlhv9f.webp"),
      img("v1785007375/DJI_20260707133512_0066_D_small_texksj.jpg"),
    ],
  },
  detailTexts: {
    JP: {
      title: "Hidden SUP Tour",
      pathTitle: "秘境SUPツアー",
      heroTitle: "SUPでしか来れない秘境へ",
      heroDescription:
        "観光マップに載っていないシークレットビーチで、誰もいないビーチであなただけの時間を満喫できる秘境SUPツアー",
      time: "約2時間",
      startTimes: ["10:00"],
      people: "1-4名様",
      heroPrice: "¥12,000",
      heroPriceNote: "税込 / 1名 ※1名参加は¥15,000",
      description:
        "SUPでしか来れない秘境へご案内します。観光マップには載っていないシークレットビーチで、誰もいないビーチであなただけの時間を満喫。究極の非日常体験を楽しめます。癒しを求める方におすすめの、少し大人な海あそびです。写真・動画・ドローン撮影まで楽しめます。",
      featureIntro:
        "SUPでしか来れない秘境へ。誰もいないビーチであなただけの時間を満喫できる、癒しを求める方におすすめの究極の非日常体験へご案内します。",
      highlights: [
        { key: "sup", icon: "option", label: { JP: "SUP体験" } },
        { key: "camera", icon: "camera", label: { JP: "写真・動画撮影" } },
        { key: "drone", icon: "drone", label: { JP: "ドローン撮影" } },
        { key: "meeting", icon: "spot", label: { JP: "現地集合" } },
      ],
      detailItems: [
        ["開始時間", "10:00"],
        ["所要時間", "約2時間"],
        ["料金", "¥12,000(税込) / 1名 ※おひとり様でご参加の場合は¥15,000"],
        ["人数", "1-4名様"],
        ["集合", "現地集合 / 事前に集合場所をご連絡"],
        ["催行場所", "海況や天気に合わせて当日ベストなポイントで開催"],
        ["年齢制限", "20歳〜40歳"],
      ],
      included: [
        "SUP体験",
        "写真・動画撮影",
        "ドローン撮影",
        "SUPボード",
        "ライフジャケット",
      ],
      notIncluded: ["食費", "個人的なお買い物"],
      price: {
        title: "Price",
        subtitle: "料金",
        list: [
          {
            priceTitle: "秘境SUPツアー",
            price: "¥12,000 / 1名",
            priceDescription:
              "2名様以上は1名¥12,000、おひとり様でご参加の場合は¥15,000です。SUP体験、写真・動画撮影、ドローン撮影込みの料金です。",
          },
        ],
      },
      faqs: [
        {
          question: "写真や動画はもらえますか？",
          answer:
            "はい。ツアー終了後、写真・映像データをお渡しします。",
        },
        {
          question: "送迎はありますか？",
          answer:
            "送迎はありません。海況や天気を確認し、その日ベストなポイントで開催するため、集合場所は事前にご連絡いたします。",
        },
        {
          question: "年齢制限はありますか？",
          answer:
            "サーフィン体験以外は、ツアーの世界観や体験コンセプト維持のため、20歳〜40歳の方を対象とさせていただいております。",
        },
        {
          question: "子供も参加できますか？",
          answer:
            "申し訳ありません。サーフィン体験以外は、大人向けの体験・撮影をコンセプトとしているため、お子様のご参加はご遠慮いただいております。",
        },
        {
          question: "支払いはいつですか？",
          answer: "当日現金でお支払いをお願いいたします。",
        },
      ],
      scheduleItems: [
        {
          time: "10:00",
          title: "集合",
          text: "海況や天気を確認し、その日ベストなポイントで開催するため、事前に集合場所をご連絡いたします。",
          image: img("v1784191145/image8_lcviao.webp"),
        },
        {
          time: "10:15",
          title: "秘境へ",
          text: "乗り方や安全面を説明してから、観光マップには載っていないシークレットビーチにSUPで向かいます。",
          image: img("v1785005393/DSC00191_small_lhfvnk.jpg"),
        },
        {
          time: "10:30",
          title: "秘境到着",
          text: "秘境でドローン撮影、一眼カメラによる撮影、自由時間。貸切のビーチで究極の非日常な時間を満喫してください。",
          image: img("v1784766585/DJI_20260722154007_0060_D_azbuxt.webp"),
        },
        {
          time: "12:00",
          title: "解散",
          text: "現地にて解散となります。写真・映像をお渡しします。",
          image: img("v1783930567/DSC00215_gpomzw.webp"),
        },
      ],
    },
    EN: {
      title: "Hidden SUP Tour",
      pathTitle: "Hidden SUP Tour",
      heroTitle: "To a hidden spot only reachable by SUP",
      heroDescription:
        "A private hidden SUP tour where you can enjoy your own quiet time on a secret beach not shown on tourist maps.",
      time: "About 2 hours",
      startTimes: ["10:00"],
      people: "1-4 guests",
      heroPrice: "¥12,000",
      heroPriceNote: "Tax included / per person / solo guest ¥15,000",
      description:
        "We guide you to hidden places that can only be reached by SUP. Spend quiet time on a secret beach away from the crowds and enjoy an extraordinary, healing ocean experience. Photo, video, and drone shooting are included.",
      featureIntro:
        "A healing private SUP experience for travelers who want their own quiet time on a beach with no one else around.",
      highlights: [
        { key: "sup", icon: "option", label: { EN: "SUP experience" } },
        { key: "camera", icon: "camera", label: { EN: "Photo and video shooting" } },
        { key: "drone", icon: "drone", label: { EN: "Drone shooting" } },
        { key: "meeting", icon: "spot", label: { EN: "Meet on site" } },
      ],
      detailItems: [
        ["Start time", "10:00"],
        ["Duration", "About 2 hours"],
        ["Price", "¥12,000 tax included / person / solo guest ¥15,000"],
        ["Guests", "1-4 guests"],
        ["Meeting", "Meet on site / location shared in advance"],
        ["Location", "Best point of the day selected based on sea and weather conditions"],
        ["Age", "20-40 years old"],
      ],
      included: ["SUP experience", "Photo and video shooting", "Drone shooting", "SUP board", "Life jacket"],
      notIncluded: ["Meals", "Personal purchases"],
      price: {
        title: "Price",
        subtitle: "Pricing",
        list: [
          {
            priceTitle: "Hidden SUP Tour",
            price: "¥12,000 / person",
            priceDescription:
              "¥12,000 per person for 2 or more guests, or ¥15,000 for a solo guest. Includes SUP experience, photo and video shooting, and drone shooting.",
          },
        ],
      },
      faqs: [
        {
          question: "Can I receive photos and videos?",
          answer:
            "Yes. We will hand over your photo and video data after the tour.",
        },
        {
          question: "Is pickup/drop-off available?",
          answer:
            "No, pickup/drop-off is not included. We check the sea and weather conditions and share the meeting location in advance so the tour can be held at the best point of the day.",
        },
        {
          question: "Is there an age limit?",
          answer:
            "To maintain the concept and atmosphere of the tour, this experience is for guests aged 20 to 40. Thank you for your understanding.",
        },
        {
          question: "When do I pay?",
          answer: "Please pay in cash on the day of the tour.",
        },
      ],
      scheduleItems: [
        { time: "10:00", title: "Meet on site", text: "We check the sea and weather conditions and share the meeting location in advance so the tour can be held at the best point of the day.", image: img("v1784191145/image8_lcviao.webp") },
        { time: "10:15", title: "To the hidden beach", text: "After explaining how to ride and stay safe, we head by SUP to a secret beach not shown on tourist maps.", image: img("v1785005393/DSC00191_small_lhfvnk.jpg") },
        { time: "10:30", title: "Arrive at the hidden beach", text: "Enjoy drone shooting, mirrorless-camera shooting, and free time on a private beach. Spend an extraordinary moment away from everything.", image: img("v1784766585/DJI_20260722154007_0060_D_azbuxt.webp") },
        { time: "12:00", title: "Finish", text: "The tour ends on site. We hand over your photos and videos.", image: img("v1783930567/DSC00215_gpomzw.webp") },
      ],
    },
    中文: {
      title: "Hidden SUP Tour",
      pathTitle: "秘境SUP行程",
      heroTitle: "前往只有SUP才能到达的秘境",
      heroDescription:
        "带你前往观光地图上没有的秘密海滩，在几乎无人的海边享受只属于自己的安静时间。",
      time: "约2小时",
      startTimes: ["10:00"],
      people: "1-4人",
      heroPrice: "¥12,000",
      heroPriceNote: "含税 / 每人 / 1人参加为¥15,000",
      description:
        "我们将带你前往只有SUP才能到达的秘境。在观光地图上没有的秘密海滩，远离人群，享受疗愈又非日常的海上体验。包含照片、视频和无人机拍摄。",
      featureIntro:
        "适合想在无人的海滩上放松、享受只属于自己时间的旅行者。",
      highlights: [
        { key: "sup", icon: "option", label: { 中文: "SUP体验" } },
        { key: "camera", icon: "camera", label: { 中文: "照片・视频拍摄" } },
        { key: "drone", icon: "drone", label: { 中文: "无人机拍摄" } },
        { key: "meeting", icon: "spot", label: { 中文: "现场集合" } },
      ],
      detailItems: [
        ["开始时间", "10:00"],
        ["所需时间", "约2小时"],
        ["价格", "¥12,000 含税 / 每人 / 1人参加为¥15,000"],
        ["人数", "1-4人"],
        ["集合", "现场集合 / 集合地点会提前通知"],
        ["举办地点", "根据当天海况和天气选择最佳地点"],
        ["年龄限制", "20岁〜40岁"],
      ],
      included: ["SUP体验", "照片・视频拍摄", "无人机拍摄", "SUP板", "救生衣"],
      notIncluded: ["餐费", "个人购物"],
      price: {
        title: "Price",
        subtitle: "价格",
        list: [
          {
            priceTitle: "秘境SUP行程",
            price: "¥12,000 / 每人",
            priceDescription:
              "2人以上每人¥12,000，1人参加为¥15,000。包含SUP体验、照片・视频拍摄和无人机拍摄。",
          },
        ],
      },
      faqs: [
        {
          question: "可以收到照片和视频吗？",
          answer: "可以。行程结束后会交付照片和视频数据。",
        },
        {
          question: "有接送服务吗？",
          answer:
            "没有接送服务。我们会根据海况和天气选择当天最佳地点，并提前通知集合地点。",
        },
        {
          question: "有年龄限制吗？",
          answer:
            "为了维持本行程的世界观和体验概念，本行程仅限20岁至40岁的客人参加。敬请理解。",
        },
        {
          question: "什么时候付款？",
          answer: "请在当天以现金付款。",
        },
      ],
      scheduleItems: [
        { time: "10:00", title: "现场集合", text: "确认海况和天气后，在当天最适合的地点举办，因此会提前通知集合地点。", image: img("v1784191145/image8_lcviao.webp") },
        { time: "10:15", title: "前往秘境", text: "说明SUP操作和安全事项后，乘SUP前往观光地图上没有的秘密海滩。", image: img("v1785005393/DSC00191_small_lhfvnk.jpg") },
        { time: "10:30", title: "抵达秘境", text: "在秘境进行无人机拍摄、相机拍摄和自由时间。在私人海滩享受极致非日常的时光。", image: img("v1784766585/DJI_20260722154007_0060_D_azbuxt.webp") },
        { time: "12:00", title: "结束", text: "现场解散，并交付照片和视频。", image: img("v1783930567/DSC00215_gpomzw.webp") },
      ],
    },
    한국어: {
      title: "Hidden SUP Tour",
      pathTitle: "비경 SUP 투어",
      heroTitle: "SUP로만 갈 수 있는 비경으로",
      heroDescription:
        "관광 지도에는 없는 시크릿 비치에서, 사람 없는 해변의 나만의 시간을 즐기는 프라이빗 SUP 투어입니다.",
      time: "약 2시간",
      startTimes: ["10:00"],
      people: "1-4명",
      heroPrice: "¥12,000",
      heroPriceNote: "세금 포함 / 1인 / 1인 참가 시 ¥15,000",
      description:
        "SUP로만 갈 수 있는 비경으로 안내합니다. 관광 지도에는 없는 시크릿 비치에서 사람 없는 조용한 시간을 보내며, 힐링이 되는 특별한 비일상 체험을 즐길 수 있습니다. 사진, 영상, 드론 촬영이 포함됩니다.",
      featureIntro:
        "사람 없는 해변에서 나만의 시간을 보내고 싶은 분께 추천하는 힐링 프라이빗 SUP 체험입니다.",
      highlights: [
        { key: "sup", icon: "option", label: { 한국어: "SUP 체험" } },
        { key: "camera", icon: "camera", label: { 한국어: "사진・영상 촬영" } },
        { key: "drone", icon: "drone", label: { 한국어: "드론 촬영" } },
        { key: "meeting", icon: "spot", label: { 한국어: "현지 집합" } },
      ],
      detailItems: [
        ["시작 시간", "10:00"],
        ["소요 시간", "약 2시간"],
        ["요금", "¥12,000 세금 포함 / 1인 / 1인 참가 시 ¥15,000"],
        ["인원", "1-4명"],
        ["집합", "현지 집합 / 집합 장소는 사전에 안내"],
        ["진행 장소", "해상 상태와 날씨에 맞춰 당일 최적의 포인트에서 진행"],
        ["연령 제한", "20세〜40세"],
      ],
      included: ["SUP 체험", "사진・영상 촬영", "드론 촬영", "SUP 보드", "구명조끼"],
      notIncluded: ["식사비", "개인 쇼핑"],
      price: {
        title: "Price",
        subtitle: "요금",
        list: [
          {
            priceTitle: "비경 SUP 투어",
            price: "¥12,000 / 1인",
            priceDescription:
              "2명 이상은 1인 ¥12,000, 1인 참가 시 ¥15,000입니다. SUP 체험, 사진・영상 촬영, 드론 촬영이 포함됩니다.",
          },
        ],
      },
      faqs: [
        {
          question: "사진이나 영상을 받을 수 있나요?",
          answer: "네. 투어 종료 후 사진과 영상 데이터를 전달드립니다.",
        },
        {
          question: "송영이 있나요?",
          answer:
            "송영은 없습니다. 해상 상태와 날씨를 확인해 당일 가장 좋은 포인트에서 진행하므로 집합 장소는 사전에 안내드립니다.",
        },
        {
          question: "연령 제한이 있나요?",
          answer:
            "투어의 분위기와 콘셉트를 유지하기 위해 20세부터 40세까지의 고객님을 대상으로 하고 있습니다. 양해 부탁드립니다.",
        },
        {
          question: "결제는 언제 하나요?",
          answer: "당일 현금으로 결제 부탁드립니다.",
        },
      ],
      scheduleItems: [
        { time: "10:00", title: "현지 집합", text: "해상 상태와 날씨를 확인해 당일 가장 좋은 포인트에서 진행하므로 집합 장소는 사전에 안내드립니다.", image: img("v1784191145/image8_lcviao.webp") },
        { time: "10:15", title: "비경으로 이동", text: "SUP 조작과 안전 설명 후, 관광 지도에는 없는 시크릿 비치로 SUP를 타고 이동합니다.", image: img("v1785005393/DSC00191_small_lhfvnk.jpg") },
        { time: "10:30", title: "비경 도착", text: "비경에서 드론 촬영, 카메라 촬영, 자유 시간을 즐깁니다. 프라이빗 비치에서 최고의 비일상 시간을 만끽해 주세요.", image: img("v1784766585/DJI_20260722154007_0060_D_azbuxt.webp") },
        { time: "12:00", title: "해산", text: "현지에서 해산하며 사진과 영상을 전달드립니다.", image: img("v1783930567/DSC00215_gpomzw.webp") },
      ],
    },
  },
};
